import React, { useMemo } from 'react';

export const PersonalizationShowSelectedContext = React.createContext(false);

export function usePersonalizationShowSelectedOnly() {
  return React.useContext(PersonalizationShowSelectedContext);
}

export function usePersonalizationFilteredContents(contents, selectedIds, resolveMappingId) {
  const showSelectedOnly = usePersonalizationShowSelectedOnly();

  return useMemo(() => {
    if (!showSelectedOnly) {
      return contents;
    }
    const selected = new Set(selectedIds || []);
    return (contents || []).filter((data) => {
      const id = resolveMappingId(data);
      return id && selected.has(id);
    });
  }, [contents, selectedIds, showSelectedOnly, resolveMappingId]);
}
